module.exports = "<div class=\"cd-kpi\" *ngFor=\"let k of kpis$ | async; trackBy: trackByLabel\">\r\n  <span class=\"cd-kpi__label\">{{ k.label }}</span>\r\n  <span class=\"cd-kpi__value\">{{ k.value }}</span>\r\n  <span\r\n    class=\"cd-kpi__sub\"\r\n    [ngClass]=\"'cd-tone--' + k.subTone\"\r\n    [title]=\"k.sub\"\r\n    >{{ k.sub }}</span\r\n  >\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/complaints/complaints-dashboard/components/dashboard-kpis/dashboard-kpis.component.html
// module id = 2415
// module chunks = 66